export const isValidISRC = (isrc: string) => {
    const cleanedISRC = isrc.replace(/-/g, '').toUpperCase();
    // eslint-disable-next-line no-useless-escape
    return /[A-Z]{2}[A-Z0-9]{3}\d{2}\d{5}/.test(cleanedISRC.trim());
};
